import { useLanguage } from "../../contexts/LanguageContext";
import printer from "../pictures/hi.jpg"
function Druk3D() {
  const { t } = useLanguage();
  return (
    <section id="druk3d" className="animate-fade-in py-12 min-h-full">
      <h1 className="text-5xl font-bold text-center mb-10 bg-clip-text text-transparent bg-gradient-to-r from-purple-500 to-cyan-500 leading-tight p-1">
        {t('print3dTitle')}
      </h1>
      <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
         <div className="group">
           <img 
              src={printer} 
              alt="3D printer" 
              className="rounded-lg shadow-lg w-full h-auto object-cover transition-all duration-300 transform group-hover:scale-105 group-hover:shadow-purple-500/20"
            />
        </div>
        <div>
          <h2 className="text-3xl font-bold text-white mb-4">{t('print3dSubtitle')}</h2>
          <p className="text-gray-400 leading-loose">
            {t('print3dText1')}
          </p>
          <p className="text-gray-400 leading-loose mt-4">
            {t('print3dText2')}
          </p>
        </div>
      </div>
    </section>
  );
};

export default Druk3D;